import React from 'react';
import "./AboutContent.css";
import ReactImage1 from "../../assets/react1.jpg";
import ReactImage2 from "../../assets/react2.webp";

function AboutContent() {
    return (
        <div className="about">
            <div className="left">
                <h1>Who Am I?</h1>
                <p>I am a Full Stack Web Developer.
                I create responsive secure websites for my clients</p>
                <a href="/contact" className="btn btn-contact">Contact</a>
            </div>
            <div className="right">
                 <div className="img-container">
                      <div className="img-stack top">
                        <img 
                        className="img"
                        src={ReactImage1}
                         alt="true"/>
                      </div>
                      <div className="img-stack bottom">
                        <img 
                        className="img"
                        src={ReactImage2}
                         alt="true"/>
                      </div>
                 </div>
            </div>
        </div>
    )
}

export default AboutContent